export default __webpack_public_path__ + "static/media/Beatnik-Parents.3300cedb.jpg";